<template>
  <CForm @submit="submit">
    <CModal :title="$t('partsPickingStatus.title')" @close="close">
      <template #body>
        <CCard class="u-mb-4">
          <h3>{{ item.description }}</h3>
          {{ props.item.code }}
        </CCard>

        <CField v-model="newStatus" type="radio" :options="[PickingStatus.PARTIAL, PickingStatus.COMPLETE]" nullable>
          <template #nullOption>
            <CFlex>
              <CIcon name="minus-double"/>
              {{ $t('partsPickingStatus.null') }}
            </CFlex>
          </template>

          <template #option="{option}">
            <CFlex>
              <CPickingStatusIcon :status="option"/>
              {{ $t(getStatusTerm(option)) }}
            </CFlex>
          </template>
        </CField>
      </template>
    </CModal>
  </CForm>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import PickingStatus from '@/dossier/constants/PickingStatus';
  import CModal from '@/general/components/CModal.vue';
  import { BasicModalResult, MODAL_CANCELLED } from '@/general/utils/Modal';
  import CCard from '@/shared/components/CCard.vue';
  import CFlex from '@/shared/components/CFlex.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CField from '@/shared/components/form/CField.vue';
  import CForm from '@/shared/components/form/CForm.vue';
  import CPickingStatusIcon from '../components/CPickingStatusIcon.vue';
  import JobItem from '../models/JobItem';

  const props = defineProps<{
    item: JobItem;
    status: PickingStatus | null;
  }>();

  const newStatus = ref(props.status);

  const emit = defineEmits<{ (e: 'close', result: PickingStatus | null | BasicModalResult): void }>();

  function getStatusTerm(status: PickingStatus) {
    switch (status) {
      case PickingStatus.TO_DO:
        return 'partsPickingStatus.notStarted';
      case PickingStatus.PARTIAL:
        return 'partsPickingStatus.partial';
      case PickingStatus.COMPLETE:
        return 'partsPickingStatus.complete';
    }
  }

  function submit() {
    emit('close', newStatus.value);
  }

  function close() {
    emit('close', MODAL_CANCELLED);
  }
</script>